module.exports = __webpack_public_path__ + "static/media/137-fiji.65d48240.svg";